module.exports = __webpack_public_path__ + "static/media/card-pos-mba.70110dcc.png";